import { render, staticRenderFns } from "./marker-transmitter.vue?vue&type=template&id=2d8469cb&scoped=true&"
import script from "./marker-transmitter.vue?vue&type=script&lang=js&"
export * from "./marker-transmitter.vue?vue&type=script&lang=js&"
import style0 from "./marker-transmitter.vue?vue&type=style&index=0&id=2d8469cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8469cb",
  null
  
)

export default component.exports